import React from "react";
import { Icon, IconProps } from "./Icon";

export const HighlightIcon = (props: IconProps) => {
  return (
    <Icon
      classes={props.classes}
      height="24px"
      width="24px"
      viewBox="0 -960 960 960"
      style={props.style}
    >
      <path d="M80 0v-160h800V0H80Zm344-640 216 217-160 160q-24 24-56.5 24T367-263l-27 23H140l126-125q-24-24-25-57.5t23-57.5l160-160Zm56-57 160-159q24-24 56.5-24t56.5 24l104 103q24 24 24 56.5T857-640L697-480 480-697Z" />
    </Icon>
  );
};
